import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem } from 'primeng/api/selectitem';
import { VerificacionObraService } from 'src/app/datos/verificacion-obra.service';
import { HttpSession, Util } from 'src/app/libs/ruvpp-angular2-comun/index';
import { ServicioIndicadorCarga } from 'src/app/libs/ruvpp-angular2-comun/indicador-carga';
import { JsonResponse } from 'src/app/libs/ruvpp-angular2-comun/modelo/Index';
import { ServicioAlertas } from 'src/app/libs/ruvpp-angular2-comun/ServicioAlertas';
import { InputReporte, OutputReporteFuncionamiento, OutputVistaInformacionGeneral, SeguridadSalida, OutputReporteDonacionesEquipamiento, ConsultaDonacionDTO } from 'src/app/modelo';

//@Autor: Ernesto López Hdez
@Component({
    selector: 'app-donaciones-equipamiento',
    templateUrl: './donaciones-equipamiento.component.html',
    //styleUrls: ['./ecotecnologias-atributos.component.css']
})
export class DonacionesEquipamientoComponent implements OnInit {

    public user: SeguridadSalida;
    public usuario: string;
    public verificador: string;

    //Forma

    public donacionesEquipamiento: OutputReporteDonacionesEquipamiento;
    public vistaInformacionGeneral: OutputVistaInformacionGeneral;
    public btn_Disabled: boolean;

    /**
     * 
     * @param servicioIndicadorCarga
     * @param servicioAlertas
     * @param service
     * @param _router
     * @param spinner
     */
    constructor(private servicioIndicadorCarga: ServicioIndicadorCarga, private servicioAlertas: ServicioAlertas, private service: VerificacionObraService, private _router: Router, private spinner: NgxSpinnerService) {

        this.user = HttpSession.getAttribute('USER');

        if (this.user != null) {
            this.usuario = `${HttpSession.getAttribute('USER_NAME')}`;
            this.verificador = `${HttpSession.getAttribute('USER_VERIFICADOR')}`;
        }

        this.vistaInformacionGeneral = HttpSession.getAttribute('ENTITY');

        console.log('DonacionesEquipamientoComponent -->> ', new Date());

    }

    /**
     * 
     */
    public async ngOnInit() {
        this.donacionesEquipamiento = <OutputReporteDonacionesEquipamiento>{ listConsultaDonacionDTO: [] };
    }

    /**
    * 
    */
    public async init() {
        await this.loading();
    }

    /**
     * 
     */
    public async loading() {

        this.btn_Disabled = true;

        this.donacionesEquipamiento = <OutputReporteDonacionesEquipamiento>{ listConsultaDonacionDTO: [] };

        let dato: InputReporte = <InputReporte>{ idOrdenVerificacion: this.vistaInformacionGeneral.ordenVerificacion };

        let resultado: JsonResponse<OutputReporteDonacionesEquipamiento> = await this.service.ObtenerReporteDonacionesEquipamiento(dato).toPromise();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            this.donacionesEquipamiento = resultado.model;

            for (let row of this.donacionesEquipamiento.listConsultaDonacionDTO) {
                row.cumple_TMPS = row.cumple;
            }

        } else {
            console.error(`---------------------------------------------------------------------------------------------------------------------`);
            console.error(`Error: `, resultado);
        }

    }

    /**
    * 
    */
    public Regresar(): void {
        Util.forward(this._router, 'VistaInformacionGeneralComponent');
    }

    /**
    * 
    */
    public async Guardar() {

        Util.showLoadingMessage(this.spinner, `Guardando información de funcionamiento ...`);

        let resultado: JsonResponse<boolean> = await this.service.GuardarReporteDonacionesEquipamiento(this.donacionesEquipamiento).toPromise();

        Util.hideLoadingMessage();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            let respuesta: boolean = resultado.model;

            if (respuesta == true) {

                this.loading();

                Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Información guardada correctamente ...', 'success');
            } else {
                Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Error al intentar guardar la información ...', 'warning');
            }

        }
    }

    /**
     * 
     */
    public async Descargar() {

    }

    /**
     * 
     * @param entity
     */
    public onRowSelectDonacionesEquipamiento(entity: any): void {

    }

    /**
     * 
     * @param entity
     */
    public onRowUnselectDonacionesEquipamiento(entity: any): void {

    }

    /**
     * 
     * @param entity
     */
    public getDisabledDonacionesEquipamiento(entity: ConsultaDonacionDTO): boolean {

        let resultado: boolean = false;

        if (entity.cumple == 0 || entity.cumple == 1) {
            resultado = true;
        } 

        return resultado;
    }

    /**
     * 
     * @param entity
     * @param value
     */
    public onChangeCumplimientoDonacionesEquipamiento(entity: ConsultaDonacionDTO, value: number) {
        entity.actualizado = true;
        entity.cumple_TMPS = value;
        this.btn_Disabled = false;
    }

}

